"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
var _phoneAuth = require("../../../../actions/phoneAuth");
var _selectors = require("./selectors");
var _reactRedux = require("react-redux");
var _ConfirmationSmsCodeFormController = require("../../../../components/ConfirmationSmsCodeFormController");
var _tracking = require("../../../../utils/tracking");
var _source = require("../../../../selectors/source");
function mapStateToProps(state) {
  return {
    sendValidationCodeStatus: (0, _selectors.sendValidationCodeStatusSelector)(state),
    isSubmitting: (0, _selectors.isPhoneAuthValidateFormSubmitting)(state),
    hasCodeError: (0, _selectors.hasRegisterOrAuthErrorSelector)(state),
    codeError: (0, _selectors.registerOrAuthErrorSelector)(state),
    resendTimeout: (0, _selectors.resendTimeoutSelector)(state),
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    verifyValidationCode(code) {
      dispatch((0, _phoneAuth.registerOrAuthorize)({
        code
      }));
    },
    sendValidationCode() {
      dispatch((0, _phoneAuth.sendCode)());
    },
    onResendClick(source) {
      (0, _tracking.trackPhoneAuthResendValidationCode)(source);
    }
  };
}
const FormContainer = exports.FormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ConfirmationSmsCodeFormController.ConfirmationSmsCodeFormController);